import { useNavigate } from 'react-router-dom'
import CustomNavbar from '../../components/common/CustomNavbar'
import PageLayout from '../../components/layouts/PageLayout'
import CustomerList from './CustomerList';

export default function Customers() {
  const navigate = useNavigate();
  return (
    <PageLayout customNavbar={
      <CustomNavbar>
        <div className="flex gap-3 items-center w-max">
          <span className="font-bold text-lg uppercase">customers information</span>
        </div>
      </CustomNavbar>
    }>
      <div className="flex flex-col items-end justify-end sm:flex-row gap-4 sm:items-center">

        <div className="relative">
          <div className="p-[2px] rounded-4xl bg-brand-blue-gradient w-full">
            <button
              className="flex w-full items-center gap-2 px-5 py-2 rounded-4xl bg-white font-semibold text-text-secondary"
            >
              Import Customers
            </button>
          </div>

        </div>

        <button
          onClick={() => navigate("/admin/customers/add")}
          className=" flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap"
        >
          + Add Customer
        </button>

      </div>

      <CustomerList />
    </PageLayout>
  )
}
